import { render, staticRenderFns } from "./diszpecserAzonosito.vue?vue&type=template&id=0a22f366"
import script from "./diszpecserAzonosito.vue?vue&type=script&lang=js"
export * from "./diszpecserAzonosito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_37b6f71ccdfa7d6e81ff3b7ec2a43a31/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports